import { Component, Inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { IValidationStatusModalData } from '../../../../shared/types/validation-status-modal-data.interface';
import { Router } from '@angular/router';
import { VerifyStatus } from '../../../../auth/core/types/verify-status.enum';

import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { KorviuButtonComponent } from '../../../../shared/components/korviu-button/korviu-button.component';
import { ShareGanasModalComponent } from '../share-ganas-modal/share-ganas-modal.component';
import { ReferralModalFacade } from '../../services/referral-modal.facade';

@Component({
  standalone: true,
  imports: [TranslateModule, NzModalModule, NzButtonModule, KorviuButtonComponent],
  selector: 'app-ganas-sharing-status-modal',
  templateUrl: './ganas-sharing-status-modal.component.html',
  styleUrl: './ganas-sharing-status-modal.component.scss'
})
export class GanasSharingStatusModalComponent {
  public VerifyGanaStatus: typeof VerifyStatus = VerifyStatus;
  public get isValidatedGanas(): boolean {
    return this.data?.status === VerifyStatus.SUCCESS;
  }

  constructor(
    @Inject(NZ_MODAL_DATA) public data: IValidationStatusModalData,
    private _router: Router,
    private _modal: NzModalRef,
    private _modalService: NzModalService,
    private _referralModalFacade: ReferralModalFacade
  ) {}

  public goToBalance(): void {
    this._router.navigate(['/workspace/balance']);
    this._modal.destroy();
  }

  public tryAgain(): void {
    this._modal.destroy();
  }

  public sendInvite(): void {
    this._openReferralModal();
    this._modal.destroy();
  }

  public openShareGanas(): void {
    this._modal.close();
    this._modalService.create({
      nzContent: ShareGanasModalComponent,
      nzWrapClassName: 'modal-wrap',
      nzClosable: false,
      nzWidth: 555,
      nzClassName: 'modal-dialog'
    });
  }

  private _openReferralModal(): void {
    this._referralModalFacade.openAddReferralModal();
    this._modal.close();
  }
}
